{
  "Login": "Iniciar sesión",
  "Email": "Email",
  "Password": "Contraseña",
  "ForgotPassword": "¿Olvidaste tu contraseña?",
  "NoAccount": "¿No tienes cuenta?",
  "Signup": "Regístrate",

  "EmptyFeildMessage": "Hm ... parece que nos saltamos un campo obligatorio.",
  "IncorrectEmailOrPassword": "Correo o contraseña incorrectos.",
  "UnableToAcceptInvitation": "No podrá aceptar la invitación con esta dirección de correo electrónico.",

  "EnterValidEmail": "Por favor introduce una dirección de correo electrónico válida.",
  "PasswordMinLength": "La contraseña debe contener 6 caracteres como mínimo",
  "WelcomeBack": "Bienvenido de nuevo",
  "ServerError": "¡Ups! Algo salió mal."
}
